import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const DraggableField = ({ field, id, handleDeleteFormField, handleDeleteModal }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="mb-3">
      <div className="flex items-center border border-gray-300 rounded-md bg-white shadow-sm overflow-hidden">
      
        <div 
          {...attributes} 
          {...listeners} 
          className="bg-gray-100 p-3 cursor-grab border-r border-gray-300 flex items-center justify-center"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="text-gray-500" viewBox="0 0 16 16">
            <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
          </svg>
        </div>
        
      
        <div className="flex-grow p-3">
          <div className="font-medium text-gray-800">{field.label}</div>
          <div className="text-sm text-gray-500 mt-1">
            Type: {field.type} | {field.required ? "Required" : "Optional"}
          </div>
          
          {field.type === "select" && field.options && (
            <div className="text-sm text-gray-500 mt-1">
              Options: {field.options.join(", ")}
            </div>
          )}
 <div className="text-sm text-gray-500 mt-1">
            Show on slack: {field.show_on_slack ? "Yes" : "No"}
          </div>
         
        </div>
        
        {/* Delete button */}
        <div className="p-3 border-l border-gray-300">
          <button 
            onClick={() => handleDeleteModal(true, id)} 
            className="text-red-500 hover:text-red-700 p-2 rounded-md hover:bg-red-50 transition-colors"
            title="Delete field"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
              <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DraggableField;